/*!
 * AquaVitales Produktkompass — Recommender (JavaScript-Port)
 * -----------------------------------------------------------------------------
 * 1:1-Portierung von includes/class-recommender.php (@version 1.2, 2026-05-19).
 * Zweck: derselbe Rechner ohne WordPress/PHP — Grundlage fuer
 *   (a) eine ECHTE Vorschau (die alte preview/index.html rechnet nur eine Attrappe)
 *   (b) die Shopify-Fassung (Camping Schorni laeuft auf Shopify, nicht WooCommerce)
 *
 * Laeuft in Browser UND Node. Keine Abhaengigkeiten.
 * Portiert: Helga, 16.07.2026 — verifiziert per tests/test-recommender.js
 * v2.8 (13.09.2026): reisedauer-Zahl, abgeleitete Felder city_druck/zweitkreis_moeglich/maschinen_am_kreislauf.
 * v2.12 (21.09.2026): netz_moeglich (Revisionsoeffnung), leitungsmaterial (Selbstausbau, nie Koffer).
 *
 * WICHTIG (Verhalten aus dem PHP uebernommen, nicht "repariert"):
 *  - items werden pro SKU UEBERSCHRIEBEN, nicht summiert. Bei zwei Regeln auf
 *    dieselbe SKU gewinnt die SPAETERE. Die Reihenfolge in rules.json ist relevant.
 *  - preis: null ergibt 0 in der Summe (PHP: null * qty === 0).
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.AVPKRecommender = factory();
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // ---- PHP-Cast-Semantik nachbilden -----------------------------------------
  // (float)null = 0, (float)"" = 0, (float)"abc" = 0, (float)"12abc" = 12
  function phpFloat(v) {
    if (v === null || v === undefined || v === false) return 0;
    if (v === true) return 1;
    if (typeof v === 'number') return isFinite(v) ? v : 0;
    var m = String(v).trim().match(/^[+-]?(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?/);
    return m ? parseFloat(m[0]) : 0;
  }
  function phpInt(v) { var f = phpFloat(v); return f < 0 ? Math.ceil(f) : Math.floor(f); }
  function round2(v) { return Math.round((v + Number.EPSILON) * 100) / 100; }

  function indexProducts(products) {
    var out = {};
    (products || []).forEach(function (p) { out[p.sku] = p; });
    return out;
  }

  // ---- derive_context() ------------------------------------------------------
  function deriveContext(answers, f) {
    var a = {};
    for (var k in answers) if (Object.prototype.hasOwnProperty.call(answers, k)) a[k] = answers[k];
    f = f || {};

    var tanks = a.tanks || [];
    var total = 0;
    if (Array.isArray(tanks)) tanks.forEach(function (t) { total += phpInt(t && t.volumen); });
    // v2.4: Beim reinen Festwasseranschluss gibt es keinen Tank — ein Volumen, das der
    // Kunde vor dem Umschalten eingetragen hat, darf die Groessenwahl nicht verfaelschen.
    if (a.versorgung === 'city') { total = 0; tanks = []; }
    a.tankvolumen_total = total;
    a.anzahl_tanks = Array.isArray(tanks) ? tanks.length : 0;

    var reisedauerMap = { kurztrip: 3, inland: 10, ausland: 17, dauer: 20 };
    var standzeitMap  = { kurz: 3, mittel: 14, lang: 90, winter: 120 };
    // v1.4: reisedauer kann als Kategorie in 'reisedauer' ODER 'reisedauer_kategorie'
    // kommen (das Frontend aus Stand A liefert 'reisedauer_kategorie').
    // v2.8 (13.09.2026): Kategorie ZUERST — das Widget schreibt in 'reisedauer' die
    // Tageszahl (mid der Option), die alte Reihenfolge fiel damit immer auf 14 Tage
    // zurueck (Pruefbericht drift-quelle-live-03). Eine echte Zahl zaehlt als Tage.
    var reisedauerKey = a.reisedauer_kategorie || a.reisedauer || '';
    if (reisedauerMap.hasOwnProperty(reisedauerKey)) {
      a.reisedauer_tage = reisedauerMap[reisedauerKey];
    } else if (typeof a.reisedauer === 'number' && isFinite(a.reisedauer) && a.reisedauer > 0) {
      a.reisedauer_tage = phpInt(a.reisedauer);
    } else {
      a.reisedauer_tage = 14;
    }
    // v1.4: standzeit kann als Kategorie ('standzeit') ODER als Zahl aus dem
    // Slider ('standzeit_tage', Stand-A-Frontend) kommen. Vorher wurde der
    // Slider-Wert ueberschrieben und die Kategorie nie abgeleitet — dadurch
    // feuerte silbernetz_je_tank nie (dokumentierter A/B-Widerspruch).
    if (standzeitMap.hasOwnProperty(a.standzeit || '')) {
      a.standzeit_tage = standzeitMap[a.standzeit];
    } else {
      var tage = phpInt(a.standzeit_tage !== undefined ? a.standzeit_tage : 14);
      if (tage <= 0) tage = 14;
      a.standzeit_tage = tage;
      if      (tage <= 6)   a.standzeit = 'kurz';
      else if (tage <= 30)  a.standzeit = 'mittel';
      else if (tage <= 119) a.standzeit = 'lang';
      else                  a.standzeit = 'winter';
    }
    a.gesamtbedarf    = phpInt(a.liter_pro_tag) * a.reisedauer_tage;
    a._gebinde_aufschlag = phpFloat((f || {}).gebinde_aufschlag_eur);

    // v1.6 (Ulrike 03.08.2026): Vorratsempfehlung fuer die Konservierung.
    // Dosierung 10 ml auf 100 Liter — gleich fuer DEXDA One und DEXDA Complete.
    // Basis ist die WASSERMENGE, nicht die Reisedauer. 20 % Reserve, nur nach oben.
    a.konserv_liter       = Math.ceil(a.gesamtbedarf * 1.2);
    a.konserv_ml          = Math.ceil(a.konserv_liter / 10);

    // v1.4: Fuer die Fest/Mobil-Weiche (UV-8 vs. UV-aid+ Koffer): externe
    // Wasserquellen entscheiden zwischen Koffer ECO und FLOW (Tauchpumpe).
    var quellen = a.quellen || [];
    a.hat_oberflaechenwasser = (Array.isArray(quellen) && quellen.indexOf('oberflaeche') !== -1) ? 'ja' : 'nein';

    // v2.8 (13.09.2026): Abgeleitete Felder, die bisher nur das Widget kannte — damit
    // Daten, Tests und Widget dieselbe Logik tragen (Pruefbericht drift-quelle-live-07).
    // city_druck: ueber 8 l/min an der Brause geht nur mit Stellplatzdruck; im Tankbetrieb
    // deckelt die Pumpe (Ulrike 02.08.2026).
    if (a.city_druck === undefined) {
      a.city_druck = (a.versorgung === 'city' || a.versorgung === 'beides') ? 'ja' : 'nein';
    }
    if (a.city_druck !== 'ja') a.dusche_durchfluss = undefined;   // Frage ohne Stellplatzdruck nicht gestellt
    // Zweiter Wasserkreislauf: nur Weltreisemobil, Boot, Hausboot MIT Maschine (Ulrike 02.08.2026).
    var zweitkreisFahrzeug = ['weltreise', 'boot', 'hausboot'].indexOf(a.fahrzeugtyp) !== -1;
    var hatMaschine = a.spuelmaschine === 'ja' || a.waschmaschine === 'ja';
    a.zweitkreis_moeglich = (zweitkreisFahrzeug && hatMaschine) ? 'ja' : 'nein';
    if (a.zweitkreis_moeglich !== 'ja') a.maschinen_kreislauf = undefined;
    // Nur ein ausdruecklicher eigener Kreislauf nimmt die Maschine aus dem UV-Weg.
    a.maschinen_am_kreislauf = (a.maschinen_kreislauf === 'eigen') ? 'nein' : 'ja';

    // v2.12 (Ulrike 21.09.2026): Netz nur, wenn der Kunde an die Revisionsoeffnung kommt —
    // sonst laesst es sich weder einlegen noch wieder herausholen. Alte Links ohne die Frage
    // zaehlen als "ja" (bisheriges Verhalten).
    a.netz_moeglich = (a.revisionsoeffnung === 'nein') ? 'nein' : 'ja';
    // v2.12: Leitungsmaterial nur beim Selbstausbau und nie beim UV-Koffer (der wird nicht
    // in die Leitung eingebaut). Fehlt die neue Frage (alte Links), zaehlt ein gesetztes
    // schlauchsystem als Selbstausbau.
    var selbstausbau = a.leitungen_vorhanden === 'selbstausbau'
      || (a.leitungen_vorhanden === undefined && !!a.schlauchsystem);
    a.leitungsmaterial = (selbstausbau && a.uv_einbau !== 'mobil') ? 'ja' : 'nein';

    // v1.5: Zapfstellen einzeln erfasst (statt der Ja/Nein-Frage 'weitere_armaturen').
    // Die alte Antwort wird daraus abgeleitet — Schlauch-/Fitting-Formeln und alte
    // gespeicherte Antworten laufen unveraendert weiter.
    var zapf = Array.isArray(a.zapfstellen) ? a.zapfstellen : [];
    a.anzahl_zapfstellen = zapf.length;
    a.hat_dusche = (zapf.indexOf('dusche_innen') !== -1 || zapf.indexOf('dusche_aussen') !== -1) ? 'ja' : 'nein';
    if (a.anzahl_zapfstellen > 0) a.weitere_armaturen = 'ja';

    var basisTab = f.basis_kalt_m_je_fahrzeugtyp || {};
    var basis = basisTab.hasOwnProperty(a.fahrzeugtyp || '') ? phpFloat(basisTab[a.fahrzeugtyp]) : 8;
    var groesseTab = f.groessenfaktor || {};
    var key = a.fahrzeuggroesse || 'mittel';
    var size = groesseTab.hasOwnProperty(key) ? phpFloat(groesseTab[key]) : 1.0;

    var praezise = phpFloat(a.fahrzeuglaenge_m);
    if (praezise > 0 && Math.abs(praezise - 7) > 0.1) {
      size = Math.max(0.5, Math.min(2.0, praezise / 7));
    }

    // v1.4.3: Kunden-Leitungswege (Tank->Kueche / Tank->Bad) haben Vorrang vor der
    // Pauschale — Ulrike 01.08.2026: "jeder Kunde weiss besser, wie sein Fahrzeug
    // ausgestattet ist." Ohne Angaben greift weiter die alte Pauschal-Schaetzung.
    var wegKueche = phpFloat(a.weg_tank_kueche);
    var wegBad = phpFloat(a.weg_tank_bad);
    var kalt;
    if (wegKueche > 0 || wegBad > 0) {
      kalt = phpFloat(f.tank_anbindung_m !== undefined ? f.tank_anbindung_m : 2);
      if (a.kueche === 'ja') kalt += wegKueche;
      if (a.weitere_armaturen === 'ja') kalt += wegBad;
      var stich = phpFloat(f.maschinen_stich_m !== undefined ? f.maschinen_stich_m : 1);
      if (a.spuelmaschine === 'ja') kalt += stich;
      if (a.waschmaschine === 'ja') kalt += stich;
    } else {
      kalt = basis * size;
      if (a.kueche && a.kueche === 'ja') kalt += phpFloat(f.aufschlag_kueche_m !== undefined ? f.aufschlag_kueche_m : 2);
      if (a.weitere_armaturen && a.weitere_armaturen === 'ja') {
        kalt += phpFloat(f.aufschlag_weitere_m !== undefined ? f.aufschlag_weitere_m : 2)
              + phpFloat(f.aufschlag_dusche_m  !== undefined ? f.aufschlag_dusche_m  : 3);
      }
    }

    var warm = 0;
    if (a.boiler && a.boiler === 'ja') {
      warm = kalt * phpFloat(f.warm_zu_kalt_anteil !== undefined ? f.warm_zu_kalt_anteil : 0.5)
           + phpFloat(f.boilerkreis_warm_m !== undefined ? f.boilerkreis_warm_m : 4);
    }
    a.schlauch_meter_kalt = Math.ceil(kalt);
    a.schlauch_meter_warm = Math.ceil(warm);

    var fit = 0;
    var proArmatur = phpInt(f.fitting_pro_armatur !== undefined ? f.fitting_pro_armatur : 2);
    fit += (a.kueche === 'ja') ? proArmatur : 0;
    fit += (a.spuelmaschine === 'ja') ? proArmatur : 0;
    // v1.5: Wenn die Zapfstellen einzeln bekannt sind, exakt je Stelle rechnen —
    // sonst wie bisher pauschal fuer Dusche+Bad schaetzen.
    if (a.anzahl_zapfstellen > 0) {
      fit += proArmatur * a.anzahl_zapfstellen;
    } else {
      fit += (a.weitere_armaturen === 'ja') ? proArmatur * 2 : 0;
    }
    fit += (a.boiler === 'ja') ? phpInt(f.fitting_pro_boiler !== undefined ? f.fitting_pro_boiler : 4) : 0;
    fit += phpInt(f.fitting_pro_tank !== undefined ? f.fitting_pro_tank : 2) * Math.max(1, a.anzahl_tanks);
    fit += phpInt(f.fitting_pro_filter !== undefined ? f.fitting_pro_filter : 2) * 2;
    a.fittings_anzahl = fit;

    return a;
  }

  // ---- rule_matches() --------------------------------------------------------
  function ruleMatches(when, ctx) {
    for (var key in when) {
      if (!Object.prototype.hasOwnProperty.call(when, key)) continue;
      var cond = when[key];
      var val = ctx.hasOwnProperty(key) ? ctx[key] : null;
      if (cond !== null && typeof cond === 'object' && !Array.isArray(cond)) {
        if (cond.min !== undefined && phpFloat(val) < phpFloat(cond.min)) return false;
        if (cond.max !== undefined && phpFloat(val) > phpFloat(cond.max)) return false;
        if (cond.in !== undefined && [].concat(cond.in).indexOf(val) === -1) return false;   // strikt
        if (cond.contains !== undefined) {
          if (!Array.isArray(val) || val.indexOf(cond.contains) === -1) return false;        // strikt
        }
      } else {
        if (val !== cond) return false;                                                       // strikt (!==)
      }
    }
    return true;
  }

  // ---- pick_from_family() ----------------------------------------------------

  // Guenstigste Kombination von Gebinden, die die Menge abdeckt (Ulrike 05.08.2026).
  // 600 Liter sind mit einem 500er + einem 100er (133,90) billiger als mit einem 1000er
  // (139,00). Mehrfach dasselbe Gebinde ist ausdruecklich erlaubt.
  // Der Aufschlag je ZUSAETZLICHEM Gebinde (rules.json formulas.gebinde_aufschlag_eur) bildet
  // Muell und Handhabung ab — sonst kaemen sechs 250-ml-Flaschen statt zwei Literflaschen,
  // um 4,40 EUR zu sparen. Er taucht in keinem Kundenpreis auf, nur in dieser Auswahl.
  function guenstigsteKombination(kandidaten, menge, grenze, aufschlag) {
    var brauchbar = kandidaten.filter(function (p) { return grenze(p) > 0 && phpFloat(p.preis) > 0; });
    if (!brauchbar.length) {
      var ersatz = kandidaten.slice().sort(function (a, b) { return grenze(b) - grenze(a); })[0];
      return ersatz ? [ersatz.sku] : [];
    }
    if (menge <= 0) menge = 1;
    var schritt = 5, ziel = Math.ceil(menge / schritt);
    var kosten = [0], wahl = [null];
    for (var i = 1; i <= ziel; i++) { kosten[i] = Infinity; wahl[i] = null; }
    for (var i = 1; i <= ziel; i++) {
      for (var k = 0; k < brauchbar.length; k++) {
        var p = brauchbar[k];
        var deckt = Math.max(1, Math.floor(grenze(p) / schritt));
        var rest = Math.max(0, i - deckt);
        var c = kosten[rest] + phpFloat(p.preis) + (rest > 0 ? aufschlag : 0);
        if (c < kosten[i]) { kosten[i] = c; wahl[i] = p; }
      }
    }
    var raus = [], i = ziel, schutz = 0;
    while (i > 0 && wahl[i] && schutz++ < 200) {
      var p = wahl[i];
      raus.push(p.sku);
      i = Math.max(0, i - Math.max(1, Math.floor(grenze(p) / schritt)));
    }
    return raus;
  }

  function pickFromFamily(candidates, strategy, ctx, add) {
    if (!candidates.length) return [];

    if (strategy === 'tank_max_liter_gte_total') {
      var needed = phpInt(ctx.tankvolumen_total);
      // Toleranz siehe PHP-Fassung und rules.json (formulas.groessen_toleranz).
      // Grenze je Artikel: 'tank_max_liter_toleriert' schlaegt den Nennwert.
      var grenze = function (p) {
        var t = phpFloat(p.tank_max_liter_toleriert);
        return t > 0 ? t : phpFloat(p.tank_max_liter);
      };
      // v1.7 (Ulrike 05.08.2026): Netze richten sich nach dem EINZELNEN Tank, wenn die
      // Tanks getrennt sind — bei verbundenen Tanks laeuft das konservierte Wasser ueber,
      // dann zaehlt das Gesamtvolumen. Reiniger und Entkalker immer Gesamtvolumen.
      var mengen = [needed];
      if (add && add.je_tank_wenn_getrennt && ctx.tanks_verbunden === 'nein') {
        var liste = (ctx.tanks || []).map(function (t) { return phpFloat(t.volumen); })
                                     .filter(function (v) { return v > 0; });
        if (liste.length) mengen = liste;
      }
      var alle = [];
      var aufschlag = phpFloat(ctx._gebinde_aufschlag);
      // v2.12 (Ulrike 08.10.2026): Silbernetz = EIN Netz pro Tank in der passenden Standardgroesse. Zwei Netze nur,
      // wenn der Kunde dadurch RICHTIG spart (add.kombi_ab_ersparnis_eur, derzeit 20 EUR) — fuer 5 EUR Differenz
      // ergibt die Kombination keinen Sinn. Passt kein einzelnes Netz (Tank > groesstes Netz), bleibt die Kombination.
      var preisVon = function (sku) { for (var q = 0; q < candidates.length; q++) if (candidates[q].sku === sku) return phpFloat(candidates[q].preis); return 0; };
      mengen.forEach(function (m) {
        var kombi = guenstigsteKombination(candidates, m, grenze, aufschlag);
        if (add && add.kombi_ab_ersparnis_eur !== undefined) {
          var passend = candidates.filter(function (p) { return grenze(p) >= m && phpFloat(p.preis) > 0; })
                                  .sort(function (x, y) { return grenze(x) - grenze(y); })[0];
          if (passend) {
            var kombiPreis = kombi.reduce(function (sum, sku) { return sum + preisVon(sku); }, 0);
            var ersparnis = phpFloat(passend.preis) - kombiPreis;
            alle = alle.concat(ersparnis >= phpFloat(add.kombi_ab_ersparnis_eur) ? kombi : [passend.sku]);
            return;
          }
        }
        alle = alle.concat(kombi);
      });
      return alle;
    }

    if (strategy === 'stufe_eq_kueche_filterstufe') {
      var stufe = ctx.kueche_filterstufe !== undefined ? ctx.kueche_filterstufe : null;
      for (var j = 0; j < candidates.length; j++) {
        var s = candidates[j].stufe !== undefined ? candidates[j].stufe : null;
        if (s === stufe) return [candidates[j].sku];
      }
      return [];
    }

    var system = ctx.schlauchsystem !== undefined ? ctx.schlauchsystem : null;
    function bySystemAndLeitung(allowed) {
      for (var k = 0; k < candidates.length; k++) {
        var p = candidates[k];
        if ((p.system || '') === system && allowed.indexOf(p.leitung || '') !== -1) return [p.sku];
      }
      return [];
    }
    if (strategy === 'system_and_leitung_kalt') return bySystemAndLeitung(['kalt', 'universal']);
    if (strategy === 'system_and_leitung_warm') return bySystemAndLeitung(['warm', 'universal']);
    if (strategy === 'system') {
      for (var m = 0; m < candidates.length; m++) {
        if ((candidates[m].system || '') === system) return [candidates[m].sku];
      }
      return [];
    }
    return [candidates[0].sku];
  }

  function resolveSkus(add, ctx, products) {
    if (add.skus && add.skus.length) return add.skus;
    if (add.sku_family) {
      var family = add.sku_family, cands = [];
      for (var sku in products) {
        if ((products[sku].kategorie || '') === family) cands.push(products[sku]);
      }
      return pickFromFamily(cands, add.select_by || '', ctx, add);
    }
    return [];
  }

  function resolveQty(add, ctx) {
    if (add.qty_formula) return phpInt(Math.max(0, phpFloat(ctx[add.qty_formula])));
    return phpInt(add.qty !== undefined ? add.qty : 1);
  }

  function renderReason(tmpl, ctx) {
    return String(tmpl || '').replace(/\{(\w+)\}/g, function (_, name) {
      var v = ctx[name];
      return (v !== undefined && v !== null && !Array.isArray(v) && typeof v !== 'object') ? String(v) : '';
    });
  }

  // ---- recommend() -----------------------------------------------------------
  // opts.anrede: 'du' nutzt rule.reason_du (Camping Schorni), sonst rule.reason (Sie).
  function recommend(answers, rules, catalog, opts) {
    var anredeDu = !!(opts && opts.anrede === 'du');
    var products = indexProducts((catalog && catalog.products) || []);
    var formulas = (rules && rules.formulas) || {};
    var ctx = deriveContext(answers || {}, formulas);

    var itemsBySku = {}, order = [];
    ((rules && rules.rules) || []).forEach(function (rule) {
      if (!ruleMatches(rule.when || {}, ctx)) return;
      var skus = resolveSkus(rule.add || {}, ctx, products);
      var qty = resolveQty(rule.add || {}, ctx);
      if (qty <= 0) return;

      // v1.7: Die Auswahl darf dieselbe Groesse mehrfach nennen (z. B. zwei getrennte
      // Tanks mit je 150 L → zweimal STSN-100). Mehrfachnennungen werden zur Stueckzahl.
      var haeufigkeit = {};
      skus.forEach(function (sku) { haeufigkeit[sku] = (haeufigkeit[sku] || 0) + 1; });
      var einmalig = [];
      skus.forEach(function (sku) { if (einmalig.indexOf(sku) === -1) einmalig.push(sku); });

      einmalig.forEach(function (sku) {
        if (!products[sku]) return;
        var p = products[sku];
        var anzahl = qty * haeufigkeit[sku];
        if (!itemsBySku[sku]) order.push(sku);
        var rctx = {};
        for (var k in ctx) rctx[k] = ctx[k];
        rctx.qty = anzahl;
        itemsBySku[sku] = {                      // UEBERSCHREIBT (wie PHP) — nicht summieren!
          sku: sku, name: p.name, qty: anzahl,
          einheit: p.einheit || 'Stk',
          preis: p.preis === undefined ? null : p.preis,
          bild: p.bild || '', kategorie: p.kategorie,
          marke: p.marke !== undefined ? p.marke : null,
          system: p.system !== undefined ? p.system : null,
          wc_product_id: p.wc_product_id !== undefined ? p.wc_product_id : null,
          reason: renderReason((anredeDu && rule.reason_du) || rule.reason || '', rctx),
          _rule: rule.id
        };
      });
    });

    var items = order.map(function (s) { return itemsBySku[s]; });
    var total = 0;
    items.forEach(function (i) { total += phpFloat(i.preis) * i.qty; });

    // v2.1: Hinweise sind Beratungstexte OHNE Produkt (z. B. Druckverlust bei
    // Tauchpumpen). Gleiche Bedingungslogik wie bei den Regeln.
    var hinweise = [];
    ((rules && rules.hinweise) || []).forEach(function (h) {
      if (!ruleMatches(h.when || {}, ctx)) return;
      var txt = (anredeDu && h.text_du) || h.text || '';
      if (txt) hinweise.push({ id: h.id, text: renderReason(txt, ctx) });
    });

    return { items: items, total: round2(total), currency: 'EUR', context: ctx,
             hinweise: hinweise, materials_buffer_pct: 10 };
  }

  return { recommend: recommend, _deriveContext: deriveContext, _ruleMatches: ruleMatches, _phpFloat: phpFloat };
}));
